<template>
  <div style="padding-top: 80px; ">
    <TopNav activeIndex="3"></TopNav>
    <div class="header">
      <div class="header-container">
        <div class="herder-title">自主研发第三代AI伴随式学生端系统</div>
        <div class="header-text">
          <p>线上、线下校区学习全记录</p>
          <!-- <p>幼儿园到高中全覆盖，让孩子用编程改变未来</p> -->
        </div>
      </div>
    </div>

    <div>
      <div class="download-container" v-for="(v, i) in softlist" :key="i">
        <div class="download-left">
          <img :src="v.img" alt="" width="100%" height="100%">
        </div>
        <div class="download-right">
          <div class="download-title">{{ v.title }}</div>
          <div class="download-text">
            <p>{{ v.des }}</p>
            <p class="download-text-bz">{{ v.bz }}</p>
          </div>
          <div class="download-btn">
            <a :href="v.loadurl">立即下载</a>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import TopNav from '@/components/top/TopNav'
import Footer from '@/components/bottom/Footer'

export default {
  components: {
    TopNav,
    Footer
  },
  data() {
    return {
      softlist: [
        {
          img: 'https://ddcoder.com/static/img/logo.ee67db4.png',
          title: '哆哆创客学生端',
          loadurl: 'https://study.ddcoder.com/download/哆哆创客学生端0.0.1.exe',
          des: '哆哆创客学生端全新升级，各种好玩的游戏作品，丰富的课程，个人自由创作作品，让你趣味学习编程，快来下载体验吧！',
          bz:'支持Windows7 以上系统'
        }
      ]
    }
  },
  mounted() {
    this.getData();
  },
  props: {},
  methods: {
    getData: function () {
      var self = this;
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var xml = this.responseXML;
          var list = [];
          var finds = xml.getElementsByTagName('item');   //获取find节点
          for (var i = 0; i < finds.length; i++) {
            var item = {};
            item.title = finds[i].getElementsByTagName('title')[0].textContent;
            item.des = finds[i].getElementsByTagName('des')[0].textContent;
            item.img = "https://study.ddcoder.com/download/" + finds[i].getElementsByTagName('img')[0].textContent;
            item.bz = finds[i].getElementsByTagName('bz')[0].textContent;
            item.loadurl = "https://study.ddcoder.com/download/" + finds[i].getElementsByTagName('name')[0].textContent +".exe";
            list.push(item);
          }
          self.softlist = list;
        }
      };
      xhttp.open("GET", "../../../static/config/softlist.xml", true);
      xhttp.send();
    }
  }
}

</script>
<style>
@import url('./works.css');
</style>



// WEBPACK FOOTER //
// src/pages/works/works.vue